import React, { useState } from 'react';
import { X, Download, Printer, Share2, Star, Edit, Trash2, History, Lock, FileText, File, Image, ChevronLeft, ChevronRight, MoreHorizontal, Users, Calendar, Tag, Clock, CheckCircle } from 'lucide-react';
export const DocumentViewer = ({
  document,
  onClose
}) => {
  const [currentTab, setCurrentTab] = useState('preview');
  const [currentPage, setCurrentPage] = useState(1);
  if (!document) return null;
  return <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center" data-id="element-398">
      <div className="bg-white w-full max-w-6xl h-[90vh] rounded-lg flex flex-col overflow-hidden" data-id="element-399">
        {/* Header */}
        <div className="px-6 py-4 border-b border-gray-200 flex items-center justify-between" data-id="element-400">
          <div className="flex items-center space-x-4" data-id="element-401">
            <div className="h-10 w-10 bg-blue-100 rounded-md flex items-center justify-center" data-id="element-402">
              <FileText className="h-6 w-6 text-blue-600" data-id="element-403" />
            </div>
            <div data-id="element-404">
              <h2 className="text-lg font-semibold text-gray-800" data-id="element-405">
                {document.name}
              </h2>
              <p className="text-sm text-gray-500" data-id="element-406">
                {document.type} • {document.size}
              </p>
            </div>
          </div>
          <div className="flex items-center space-x-3" data-id="element-407">
            <button className="p-2 text-gray-500 hover:text-gray-700 hover:bg-gray-100 rounded-full" data-id="element-408">
              <Download className="h-5 w-5" data-id="element-409" />
            </button>
            <button className="p-2 text-gray-500 hover:text-gray-700 hover:bg-gray-100 rounded-full" data-id="element-410">
              <Printer className="h-5 w-5" data-id="element-411" />
            </button>
            <button className="p-2 text-gray-500 hover:text-gray-700 hover:bg-gray-100 rounded-full" data-id="element-412">
              <Share2 className="h-5 w-5" data-id="element-413" />
            </button>
            <button className="p-2 text-gray-500 hover:text-gray-700 hover:bg-gray-100 rounded-full" data-id="element-414">
              <Star className="h-5 w-5" data-id="element-415" />
            </button>
            <button className="p-2 text-gray-500 hover:text-gray-700 hover:bg-gray-100 rounded-full" onClick={onClose} data-id="element-416">
              <X className="h-5 w-5" data-id="element-417" />
            </button>
          </div>
        </div>
        {/* Tabs */}
        <div className="px-6 py-2 border-b border-gray-200 flex space-x-6" data-id="element-418">
          <button className={`py-2 px-1 text-sm font-medium ${currentTab === 'preview' ? 'text-blue-600 border-b-2 border-blue-600' : 'text-gray-600'}`} onClick={() => setCurrentTab('preview')} data-id="element-419">
            Preview
          </button>
          <button className={`py-2 px-1 text-sm font-medium ${currentTab === 'details' ? 'text-blue-600 border-b-2 border-blue-600' : 'text-gray-600'}`} onClick={() => setCurrentTab('details')} data-id="element-420">
            Details
          </button>
          <button className={`py-2 px-1 text-sm font-medium ${currentTab === 'history' ? 'text-blue-600 border-b-2 border-blue-600' : 'text-gray-600'}`} onClick={() => setCurrentTab('history')} data-id="element-421">
            Version History
          </button>
          <button className={`py-2 px-1 text-sm font-medium ${currentTab === 'permissions' ? 'text-blue-600 border-b-2 border-blue-600' : 'text-gray-600'}`} onClick={() => setCurrentTab('permissions')} data-id="element-422">
            Permissions
          </button>
          <button className={`py-2 px-1 text-sm font-medium ${currentTab === 'workflow' ? 'text-blue-600 border-b-2 border-blue-600' : 'text-gray-600'}`} onClick={() => setCurrentTab('workflow')} data-id="element-423">
            Workflow
          </button>
        </div>
        {/* Content */}
        <div className="flex-1 overflow-auto" data-id="element-424">
          {currentTab === 'preview' && <div className="h-full flex flex-col" data-id="element-425">
              <div className="flex-1 bg-gray-100 flex items-center justify-center relative" data-id="element-426">
                {/* Document preview placeholder */}
                <div className="bg-white shadow-md w-[80%] h-[90%] flex items-center justify-center" data-id="element-427">
                  {document.type === 'PDF' ? <div className="text-center" data-id="element-428">
                      <FileText className="h-16 w-16 text-gray-400 mx-auto mb-4" data-id="element-429" />
                      <p className="text-gray-600" data-id="element-430">PDF Preview</p>
                      <p className="text-sm text-gray-500 mt-2" data-id="element-431">
                        Page {currentPage} of 12
                      </p>
                    </div> : document.type === 'Image' ? <div className="text-center" data-id="element-432">
                      <Image className="h-16 w-16 text-gray-400 mx-auto mb-4" data-id="element-433" />
                      <p className="text-gray-600" data-id="element-434">Image Preview</p>
                    </div> : <div className="text-center" data-id="element-435">
                      <File className="h-16 w-16 text-gray-400 mx-auto mb-4" data-id="element-436" />
                      <p className="text-gray-600" data-id="element-437">Document Preview</p>
                    </div>}
                </div>
                {/* Navigation buttons */}
                <button className="absolute left-4 top-1/2 transform -translate-y-1/2 p-2 bg-white rounded-full shadow-md text-gray-600 hover:text-gray-800" data-id="element-438">
                  <ChevronLeft className="h-5 w-5" data-id="element-439" />
                </button>
                <button className="absolute right-4 top-1/2 transform -translate-y-1/2 p-2 bg-white rounded-full shadow-md text-gray-600 hover:text-gray-800" data-id="element-440">
                  <ChevronRight className="h-5 w-5" data-id="element-441" />
                </button>
              </div>
              {/* Bottom toolbar */}
              <div className="px-6 py-3 border-t border-gray-200 flex items-center justify-between bg-white" data-id="element-442">
                <div className="flex items-center space-x-4" data-id="element-443">
                  <button className="p-1 text-gray-500 hover:text-gray-700" data-id="element-444">
                    <ChevronLeft className="h-5 w-5" data-id="element-445" />
                  </button>
                  <span className="text-sm text-gray-600" data-id="element-446">
                    Page {currentPage} of 12
                  </span>
                  <button className="p-1 text-gray-500 hover:text-gray-700" data-id="element-447">
                    <ChevronRight className="h-5 w-5" data-id="element-448" />
                  </button>
                </div>
                <div className="flex items-center space-x-2" data-id="element-449">
                  <button className="px-3 py-1 text-sm text-gray-600 border border-gray-300 rounded-md hover:bg-gray-50" data-id="element-450">
                    Zoom In
                  </button>
                  <button className="px-3 py-1 text-sm text-gray-600 border border-gray-300 rounded-md hover:bg-gray-50" data-id="element-451">
                    Zoom Out
                  </button>
                  <button className="p-1 text-gray-500 hover:text-gray-700" data-id="element-452">
                    <MoreHorizontal className="h-5 w-5" data-id="element-453" />
                  </button>
                </div>
              </div>
            </div>}
          {currentTab === 'details' && <div className="p-6" data-id="element-454">
              <div className="grid grid-cols-2 gap-6" data-id="element-455">
                <div data-id="element-456">
                  <h3 className="text-lg font-medium text-gray-800 mb-4" data-id="element-457">
                    Document Information
                  </h3>
                  <div className="space-y-4" data-id="element-458">
                    <div className="flex items-start" data-id="element-459">
                      <div className="w-32 text-sm text-gray-500" data-id="element-460">Name</div>
                      <div className="flex-1 text-sm text-gray-800" data-id="element-461">
                        {document.name}
                      </div>
                    </div>
                    <div className="flex items-start" data-id="element-462">
                      <div className="w-32 text-sm text-gray-500" data-id="element-463">Type</div>
                      <div className="flex-1 text-sm text-gray-800" data-id="element-464">
                        {document.type}
                      </div>
                    </div>
                    <div className="flex items-start" data-id="element-465">
                      <div className="w-32 text-sm text-gray-500" data-id="element-466">Size</div>
                      <div className="flex-1 text-sm text-gray-800" data-id="element-467">
                        {document.size}
                      </div>
                    </div>
                    <div className="flex items-start" data-id="element-468">
                      <div className="w-32 text-sm text-gray-500" data-id="element-469">Created</div>
                      <div className="flex-1 text-sm text-gray-800" data-id="element-470">
                        Aug 10, 2023 at 10:30 AM
                      </div>
                    </div>
                    <div className="flex items-start" data-id="element-471">
                      <div className="w-32 text-sm text-gray-500" data-id="element-472">Modified</div>
                      <div className="flex-1 text-sm text-gray-800" data-id="element-473">
                        {document.modified}
                      </div>
                    </div>
                    <div className="flex items-start" data-id="element-474">
                      <div className="w-32 text-sm text-gray-500" data-id="element-475">Owner</div>
                      <div className="flex-1 text-sm text-gray-800" data-id="element-476">
                        Jasim Alawadhi
                      </div>
                    </div>
                    <div className="flex items-start" data-id="element-477">
                      <div className="w-32 text-sm text-gray-500" data-id="element-478">
                        Department
                      </div>
                      <div className="flex-1 text-sm text-gray-800" data-id="element-479">
                        General Manager Office
                      </div>
                    </div>
                  </div>
                </div>
                <div data-id="element-480">
                  <h3 className="text-lg font-medium text-gray-800 mb-4" data-id="element-481">
                    Metadata
                  </h3>
                  <div className="space-y-4" data-id="element-482">
                    <div className="flex items-start" data-id="element-483">
                      <div className="w-32 text-sm text-gray-500" data-id="element-484">Status</div>
                      <div className="flex-1" data-id="element-485">
                        <span className={`px-2 py-1 text-xs rounded-full ${getStatusColor(document.status)}`} data-id="element-486">
                          {document.status}
                        </span>
                      </div>
                    </div>
                    <div className="flex items-start" data-id="element-487">
                      <div className="w-32 text-sm text-gray-500" data-id="element-488">Tags</div>
                      <div className="flex-1 flex flex-wrap gap-2" data-id="element-489">
                        <span className="px-2 py-1 bg-blue-100 text-blue-800 text-xs rounded-full" data-id="element-490">
                          Report
                        </span>
                        <span className="px-2 py-1 bg-purple-100 text-purple-800 text-xs rounded-full" data-id="element-491">
                          Finance
                        </span>
                        <span className="px-2 py-1 bg-green-100 text-green-800 text-xs rounded-full" data-id="element-492">
                          2023
                        </span>
                      </div>
                    </div>
                    <div className="flex items-start" data-id="element-493">
                      <div className="w-32 text-sm text-gray-500" data-id="element-494">
                        Retention
                      </div>
                      <div className="flex-1 text-sm text-gray-800" data-id="element-495">
                        7 years (until 2030)
                      </div>
                    </div>
                    <div className="flex items-start" data-id="element-496">
                      <div className="w-32 text-sm text-gray-500" data-id="element-497">Category</div>
                      <div className="flex-1 text-sm text-gray-800" data-id="element-498">
                        Financial Documents
                      </div>
                    </div>
                    <div className="flex items-start" data-id="element-499">
                      <div className="w-32 text-sm text-gray-500" data-id="element-500">
                        Reference ID
                      </div>
                      <div className="flex-1 text-sm text-gray-800" data-id="element-501">
                        DOC-2023-{document.id}
                      </div>
                    </div>
                  </div>
                  <div className="mt-8" data-id="element-502">
                    <h3 className="text-lg font-medium text-gray-800 mb-4" data-id="element-503">
                      Actions
                    </h3>
                    <div className="flex flex-wrap gap-3" data-id="element-504">
                      <button className="flex items-center space-x-2 px-3 py-2 border border-gray-300 rounded-md text-sm text-gray-700 hover:bg-gray-50" data-id="element-505">
                        <Edit className="h-4 w-4" data-id="element-506" />
                        <span data-id="element-507">Edit</span>
                      </button>
                      <button className="flex items-center space-x-2 px-3 py-2 border border-gray-300 rounded-md text-sm text-gray-700 hover:bg-gray-50" data-id="element-508">
                        <History className="h-4 w-4" data-id="element-509" />
                        <span data-id="element-510">View History</span>
                      </button>
                      <button className="flex items-center space-x-2 px-3 py-2 border border-gray-300 rounded-md text-sm text-red-600 hover:bg-red-50" data-id="element-511">
                        <Trash2 className="h-4 w-4" data-id="element-512" />
                        <span data-id="element-513">Delete</span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>}
          {currentTab === 'history' && <div className="p-6" data-id="element-514">
              <h3 className="text-lg font-medium text-gray-800 mb-4" data-id="element-515">
                Version History
              </h3>
              <div className="border border-gray-200 rounded-lg overflow-hidden" data-id="element-516">
                <table className="min-w-full divide-y divide-gray-200" data-id="element-517">
                  <thead className="bg-gray-50" data-id="element-518">
                    <tr data-id="element-519">
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-520">
                        Version
                      </th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-521">
                        Modified By
                      </th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-522">
                        Date
                      </th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-523">
                        Comments
                      </th>
                      <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-524">
                        Actions
                      </th>
                    </tr>
                  </thead>
                  <tbody className="bg-white divide-y divide-gray-200" data-id="element-525">
                    <tr data-id="element-526">
                      <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900" data-id="element-527">
                        v3.0 (Current)
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-528">
                        Jasim Alawadhi
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-529">
                        {document.modified}
                      </td>
                      <td className="px-6 py-4 text-sm text-gray-500" data-id="element-530">
                        Final review changes
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium" data-id="element-531">
                        <button className="text-blue-600 hover:text-blue-900 mr-3" data-id="element-532">
                          View
                        </button>
                        <button className="text-blue-600 hover:text-blue-900" data-id="element-533">
                          Restore
                        </button>
                      </td>
                    </tr>
                    <tr data-id="element-534">
                      <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900" data-id="element-535">
                        v2.0
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-536">
                        Fatima Ahmed
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-537">
                        Aug 8, 2023
                      </td>
                      <td className="px-6 py-4 text-sm text-gray-500" data-id="element-538">
                        Updated financial figures
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium" data-id="element-539">
                        <button className="text-blue-600 hover:text-blue-900 mr-3" data-id="element-540">
                          View
                        </button>
                        <button className="text-blue-600 hover:text-blue-900" data-id="element-541">
                          Restore
                        </button>
                      </td>
                    </tr>
                    <tr data-id="element-542">
                      <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900" data-id="element-543">
                        v1.0
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-544">
                        Mohammed Ali
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-545">
                        Aug 5, 2023
                      </td>
                      <td className="px-6 py-4 text-sm text-gray-500" data-id="element-546">
                        Initial draft
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium" data-id="element-547">
                        <button className="text-blue-600 hover:text-blue-900 mr-3" data-id="element-548">
                          View
                        </button>
                        <button className="text-blue-600 hover:text-blue-900" data-id="element-549">
                          Restore
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>}
          {currentTab === 'permissions' && <div className="p-6" data-id="element-550">
              <div className="flex justify-between items-center mb-4" data-id="element-551">
                <h3 className="text-lg font-medium text-gray-800" data-id="element-552">
                  Permissions
                </h3>
                <button className="px-3 py-2 bg-blue-600 text-white rounded-md text-sm hover:bg-blue-700 transition-colors flex items-center space-x-2" data-id="element-553">
                  <Users className="h-4 w-4" data-id="element-554" />
                  <span data-id="element-555">Share Document</span>
                </button>
              </div>
              <div className="border border-gray-200 rounded-lg overflow-hidden mb-6" data-id="element-556">
                <table className="min-w-full divide-y divide-gray-200" data-id="element-557">
                  <thead className="bg-gray-50" data-id="element-558">
                    <tr data-id="element-559">
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-560">
                        User/Group
                      </th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-561">
                        Permission Level
                      </th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-562">
                        Granted By
                      </th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-563">
                        Date
                      </th>
                      <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-564">
                        Actions
                      </th>
                    </tr>
                  </thead>
                  <tbody className="bg-white divide-y divide-gray-200" data-id="element-565">
                    <tr data-id="element-566">
                      <td className="px-6 py-4 whitespace-nowrap" data-id="element-567">
                        <div className="flex items-center" data-id="element-568">
                          <div className="h-8 w-8 rounded-full bg-blue-100 flex items-center justify-center text-xs font-medium text-blue-800" data-id="element-569">
                            JA
                          </div>
                          <div className="ml-3" data-id="element-570">
                            <div className="text-sm font-medium text-gray-900" data-id="element-571">
                              Jasim Alawadhi
                            </div>
                            <div className="text-xs text-gray-500" data-id="element-572">Owner</div>
                          </div>
                        </div>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap" data-id="element-573">
                        <span className="px-2 py-1 text-xs rounded-full bg-green-100 text-green-800" data-id="element-574">
                          Full Control
                        </span>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-575">
                        System
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-576">
                        Aug 5, 2023
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium" data-id="element-577">
                        <button className="text-gray-400 cursor-not-allowed" data-id="element-578">
                          <Lock className="h-4 w-4" data-id="element-579" />
                        </button>
                      </td>
                    </tr>
                    <tr data-id="element-580">
                      <td className="px-6 py-4 whitespace-nowrap" data-id="element-581">
                        <div className="flex items-center" data-id="element-582">
                          <div className="h-8 w-8 rounded-full bg-purple-100 flex items-center justify-center text-xs font-medium text-purple-800" data-id="element-583">
                            <Users className="h-4 w-4" data-id="element-584" />
                          </div>
                          <div className="ml-3" data-id="element-585">
                            <div className="text-sm font-medium text-gray-900" data-id="element-586">
                              Finance Department
                            </div>
                            <div className="text-xs text-gray-500" data-id="element-587">Group</div>
                          </div>
                        </div>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap" data-id="element-588">
                        <span className="px-2 py-1 text-xs rounded-full bg-blue-100 text-blue-800" data-id="element-589">
                          Edit
                        </span>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-590">
                        Jasim Alawadhi
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-591">
                        Aug 5, 2023
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium" data-id="element-592">
                        <button className="text-blue-600 hover:text-blue-900" data-id="element-593">
                          Edit
                        </button>
                      </td>
                    </tr>
                    <tr data-id="element-594">
                      <td className="px-6 py-4 whitespace-nowrap" data-id="element-595">
                        <div className="flex items-center" data-id="element-596">
                          <div className="h-8 w-8 rounded-full bg-gray-100 flex items-center justify-center text-xs font-medium text-gray-800" data-id="element-597">
                            <Users className="h-4 w-4" data-id="element-598" />
                          </div>
                          <div className="ml-3" data-id="element-599">
                            <div className="text-sm font-medium text-gray-900" data-id="element-600">
                              All Staff
                            </div>
                            <div className="text-xs text-gray-500" data-id="element-601">Group</div>
                          </div>
                        </div>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap" data-id="element-602">
                        <span className="px-2 py-1 text-xs rounded-full bg-gray-100 text-gray-800" data-id="element-603">
                          View Only
                        </span>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-604">
                        Jasim Alawadhi
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-605">
                        Aug 7, 2023
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium" data-id="element-606">
                        <button className="text-blue-600 hover:text-blue-900" data-id="element-607">
                          Edit
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4" data-id="element-608">
                <div className="flex items-start" data-id="element-609">
                  <div className="flex-shrink-0 mt-0.5" data-id="element-610">
                    <Lock className="h-5 w-5 text-yellow-500" data-id="element-611" />
                  </div>
                  <div className="ml-3" data-id="element-612">
                    <h4 className="text-sm font-medium text-yellow-800" data-id="element-613">
                      Security Notice
                    </h4>
                    <p className="text-sm text-yellow-700 mt-1" data-id="element-614">
                      This document inherits permissions from the General
                      Manager Office department. Any changes to department
                      permissions will affect this document.
                    </p>
                  </div>
                </div>
              </div>
            </div>}
          {currentTab === 'workflow' && <div className="p-6" data-id="element-615">
              <div className="flex justify-between items-center mb-6" data-id="element-616">
                <h3 className="text-lg font-medium text-gray-800" data-id="element-617">
                  Current Workflow
                </h3>
                <div className="flex items-center space-x-3" data-id="element-618">
                  <span className="px-3 py-1 bg-blue-100 text-blue-800 text-sm rounded-full flex items-center" data-id="element-619">
                    <Clock className="h-4 w-4 mr-1" data-id="element-620" />
                    In Progress
                  </span>
                  <button className="px-3 py-2 border border-gray-300 rounded-md text-sm text-gray-700 hover:bg-gray-50" data-id="element-621">
                    View Full Workflow
                  </button>
                </div>
              </div>
              <div className="relative pb-12" data-id="element-622">
                <div className="absolute inset-0 flex items-center justify-center" data-id="element-623">
                  <div className="w-full border-t border-gray-300" data-id="element-624"></div>
                </div>
                <div className="relative flex justify-between" data-id="element-625">
                  <div className="flex flex-col items-center" data-id="element-626">
                    <div className="bg-green-100 rounded-full h-12 w-12 flex items-center justify-center z-10" data-id="element-627">
                      <CheckCircle className="h-6 w-6 text-green-600" data-id="element-628" />
                    </div>
                    <div className="text-sm font-medium text-gray-700 mt-2" data-id="element-629">
                      Document Creation
                    </div>
                    <div className="text-xs text-gray-500 mt-1" data-id="element-630">
                      Aug 5, 2023
                    </div>
                  </div>
                  <div className="flex flex-col items-center" data-id="element-631">
                    <div className="bg-green-100 rounded-full h-12 w-12 flex items-center justify-center z-10" data-id="element-632">
                      <CheckCircle className="h-6 w-6 text-green-600" data-id="element-633" />
                    </div>
                    <div className="text-sm font-medium text-gray-700 mt-2" data-id="element-634">
                      Department Review
                    </div>
                    <div className="text-xs text-gray-500 mt-1" data-id="element-635">
                      Aug 8, 2023
                    </div>
                  </div>
                  <div className="flex flex-col items-center" data-id="element-636">
                    <div className="bg-blue-100 rounded-full h-12 w-12 flex items-center justify-center z-10" data-id="element-637">
                      <Clock className="h-6 w-6 text-blue-600" data-id="element-638" />
                    </div>
                    <div className="text-sm font-medium text-gray-700 mt-2" data-id="element-639">
                      Finance Approval
                    </div>
                    <div className="text-xs text-gray-500 mt-1" data-id="element-640">
                      In Progress
                    </div>
                  </div>
                  <div className="flex flex-col items-center" data-id="element-641">
                    <div className="bg-gray-100 rounded-full h-12 w-12 flex items-center justify-center z-10" data-id="element-642">
                      <div className="h-3 w-3 rounded-full bg-gray-400" data-id="element-643"></div>
                    </div>
                    <div className="text-sm font-medium text-gray-700 mt-2" data-id="element-644">
                      GM Approval
                    </div>
                    <div className="text-xs text-gray-500 mt-1" data-id="element-645">Pending</div>
                  </div>
                  <div className="flex flex-col items-center" data-id="element-646">
                    <div className="bg-gray-100 rounded-full h-12 w-12 flex items-center justify-center z-10" data-id="element-647">
                      <div className="h-3 w-3 rounded-full bg-gray-400" data-id="element-648"></div>
                    </div>
                    <div className="text-sm font-medium text-gray-700 mt-2" data-id="element-649">
                      Final Archive
                    </div>
                    <div className="text-xs text-gray-500 mt-1" data-id="element-650">Pending</div>
                  </div>
                </div>
              </div>
              <div className="mt-8" data-id="element-651">
                <h4 className="text-md font-medium text-gray-800 mb-4" data-id="element-652">
                  Recent Activity
                </h4>
                <div className="space-y-4" data-id="element-653">
                  <div className="flex items-start" data-id="element-654">
                    <div className="h-8 w-8 rounded-full bg-blue-100 flex items-center justify-center flex-shrink-0" data-id="element-655">
                      <Calendar className="h-4 w-4 text-blue-600" data-id="element-656" />
                    </div>
                    <div className="ml-3" data-id="element-657">
                      <p className="text-sm text-gray-800" data-id="element-658">
                        <span className="font-medium" data-id="element-659">Fatima Ahmed</span>{' '}
                        reviewed the document
                      </p>
                      <p className="text-xs text-gray-500 mt-1" data-id="element-660">
                        Aug 8, 2023 at 2:45 PM
                      </p>
                    </div>
                  </div>
                  <div className="flex items-start" data-id="element-661">
                    <div className="h-8 w-8 rounded-full bg-green-100 flex items-center justify-center flex-shrink-0" data-id="element-662">
                      <CheckCircle className="h-4 w-4 text-green-600" data-id="element-663" />
                    </div>
                    <div className="ml-3" data-id="element-664">
                      <p className="text-sm text-gray-800" data-id="element-665">
                        <span className="font-medium" data-id="element-666">Department Review</span>{' '}
                        stage completed
                      </p>
                      <p className="text-xs text-gray-500 mt-1" data-id="element-667">
                        Aug 8, 2023 at 3:10 PM
                      </p>
                    </div>
                  </div>
                  <div className="flex items-start" data-id="element-668">
                    <div className="h-8 w-8 rounded-full bg-purple-100 flex items-center justify-center flex-shrink-0" data-id="element-669">
                      <Tag className="h-4 w-4 text-purple-600" data-id="element-670" />
                    </div>
                    <div className="ml-3" data-id="element-671">
                      <p className="text-sm text-gray-800" data-id="element-672">
                        <span className="font-medium" data-id="element-673">Jasim Alawadhi</span>{' '}
                        added tag <span className="font-medium" data-id="element-674">Finance</span>
                      </p>
                      <p className="text-xs text-gray-500 mt-1" data-id="element-675">
                        Aug 9, 2023 at 9:15 AM
                      </p>
                    </div>
                  </div>
                  <div className="flex items-start" data-id="element-676">
                    <div className="h-8 w-8 rounded-full bg-yellow-100 flex items-center justify-center flex-shrink-0" data-id="element-677">
                      <Clock className="h-4 w-4 text-yellow-600" data-id="element-678" />
                    </div>
                    <div className="ml-3" data-id="element-679">
                      <p className="text-sm text-gray-800" data-id="element-680">
                        <span className="font-medium" data-id="element-681">Finance Approval</span>{' '}
                        stage started
                      </p>
                      <p className="text-xs text-gray-500 mt-1" data-id="element-682">
                        Aug 9, 2023 at 9:30 AM
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>}
        </div>
      </div>
    </div>;
};
const getStatusColor = status => {
  switch (status) {
    case 'Active':
      return 'bg-green-100 text-green-800';
    case 'Archived':
      return 'bg-gray-100 text-gray-800';
    case 'Draft':
      return 'bg-yellow-100 text-yellow-800';
    case 'Pending':
      return 'bg-blue-100 text-blue-800';
    default:
      return 'bg-gray-100 text-gray-800';
  }
};